<template>
  <div>
    <h4>Dodaj materijal</h4>
    <form v-on:submit.prevent="addMats">
      <div class="form-group">
        <label for="materialName">Materijal</label>
        <input
          type="text"
          class="form-control"
          id="materialName"
          placeholder="Material used"
          v-model="name"
        />
        <div class="form-group mt-4">
          <label for="unit">Jedinica mjere</label>
          <select class="form-control" id="unit" @change="selectUnits">
            <option :selected="selected">{{
              selected === true ? "Select unit" : selected
            }}</option>
            <option v-for="unit in getOptions.units" :key="unit.index">{{
              unit
            }}</option>
          </select>
        </div>
        <div>
          <numerictextbox
            :placeholder="'please enter value'"
            :format="format"
            :step="step"
            v-model="value"
          >
          </numerictextbox>

          <div class="row mt-3">
            <button type="submit" class="btn btn-primary" style="width:150px;">
              Dodaj materijal
            </button>
          </div>
        </div>
      </div>
    </form>
  </div>
</template>
<script>
import { NumericTextBox } from "@progress/kendo-vue-inputs";
import EventBus from "@/eventBus";
export default {
  /*eslint-disable*/
  components: {
    numerictextbox: NumericTextBox
  },
  mounted() {
    // this.name = this.data.materialName;
    // this.unit = this.data.unit;
    // this.value = this.data.value;
    // this.$store.commit("addMaterials", this.data);
    // }
    EventBus.$on("EDIT_MODE", response => {
      if (response) {
        this.units = response.unit;
        this.value = response.value;
        this.name = response.materialName;
        this.selected = response.unit;
        this.editMode = true;
        this.id = response.id;
      }
    });
  },
  data() {
    return {
      numericBoxValuesValues: {
        kom: { format: "n0", default: 5, step: 1 },
        kg: { format: "n2", default: 1, step: 0.1 },
        m: { format: "n2", default: 1, step: 0.1 }
      },
      units: "",
      format: "",
      defaultValues: 0,
      step: 1,
      value: 1,
      name: "",
      added: true,
      selected: true,
      editMode: false,
      id: 0
    };
  },
  props: {
    data: Object
  },
  methods: {
    onSubmit() {
      alert("BLUR");
    },
    selectUnits(event) {
      this.units = event.target.value;
      const format = this.numericBoxValuesValues[this.units].format;
      const step = this.numericBoxValuesValues[this.units].step;
      this.format = format;
      this.step = step;
    },
    addMats(event) {
      var number = Math.random();
      number.toString(36);
      var id = this.editMode ? this.id : number.toString(36).substr(2, 9);

      const newMaterial = {
        id: id,
        materialName: this.name,
        unit: this.units,
        value: this.value
      };
      this.added = false;
      //this.$store.commit("addMaterials", newMaterial);
      event.target.reset();
      this.editMode = false;
      this.$emit("newMaterial", newMaterial);
    }
  },
  computed: {
    getOptions() {
      return this.$store.getters.getOptions;
    }
  }
};
</script>
<style scoped>
.btn {
  display: block;
  width: 70px;
  background-color: DodgerBlue;
  border: none;
  color: white;
  padding: 12px 16px;
  font-size: 16px;
  cursor: pointer;
  margin-top: 20px;
}
.btn:hover {
  background-color: RoyalBlue;
}
</style>
